export default __webpack_public_path__ + "static/media/canva.60dcc087.webp";